import React from 'react';
import { CTAButton } from '../components/CTAButton';
import { SectionReveal } from '../components/SectionReveal';
import { CheckIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="relative w-full bg-brand-dark py-20 md:py-28 overflow-hidden" data-id="element-193">
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-brand-green/30 to-transparent" data-id="element-194" />

      <div className="relative z-10 max-w-3xl mx-auto px-4" data-id="element-195">
        <SectionReveal data-id="element-196">
          <p className="text-4xl mb-4 text-center" data-id="element-197">🧩</p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-white text-center mb-4 uppercase" data-id="element-198">
            Por eso creamos esta guía.
          </h2>
          <p className="text-xl sm:text-2xl text-gray-300 font-body text-center mb-10" data-id="element-199">
            Una forma simple y directa de:
          </p>
        </SectionReveal>

        <SectionReveal delay={0.1} data-id="element-200">
          <div className="space-y-5 mb-12 max-w-xl mx-auto" data-id="element-201">
            <div className="flex items-center gap-4 bg-brand-green/10 border border-brand-green/20 rounded-lg p-5" data-id="element-202">
              <div className="w-8 h-8 bg-brand-green rounded-full flex items-center justify-center flex-shrink-0" data-id="element-203">
                <CheckIcon className="w-5 h-5 text-white" aria-hidden="true" data-id="element-204" />
              </div>
              <p className="text-gray-100 font-body text-lg font-semibold m-0" data-id="element-205">
                Detectar consumos ocultos
              </p>
            </div>
            <div className="flex items-center gap-4 bg-brand-green/10 border border-brand-green/20 rounded-lg p-5" data-id="element-206">
              <div className="w-8 h-8 bg-brand-green rounded-full flex items-center justify-center flex-shrink-0" data-id="element-207">
                <CheckIcon className="w-5 h-5 text-white" aria-hidden="true" data-id="element-208" />
              </div>
              <p className="text-gray-100 font-body text-lg font-semibold m-0" data-id="element-209">
                Corregir errores comunes
              </p>
            </div>
            <div className="flex items-center gap-4 bg-brand-green/10 border border-brand-green/20 rounded-lg p-5" data-id="element-210">
              <div className="w-8 h-8 bg-brand-green rounded-full flex items-center justify-center flex-shrink-0" data-id="element-211">
                <CheckIcon className="w-5 h-5 text-white" aria-hidden="true" data-id="element-212" />
              </div>
              <p className="text-gray-100 font-body text-lg font-semibold m-0" data-id="element-213">
                Optimizar el uso de energía en tu casa
              </p>
            </div>
            <div className="flex items-center gap-4 bg-brand-green/10 border border-brand-green/20 rounded-lg p-5" data-id="element-214">
              <div className="w-8 h-8 bg-brand-green rounded-full flex items-center justify-center flex-shrink-0" data-id="element-215">
                <CheckIcon className="w-5 h-5 text-white" aria-hidden="true" data-id="element-216" />
              </div>
              <p className="text-gray-100 font-body text-lg font-semibold m-0" data-id="element-217">
                Reducir el monto de tu próxima factura
              </p>
            </div>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.2} data-id="element-218">
          <div className="text-center mb-12" data-id="element-219">
            <p className="text-xl sm:text-2xl text-gray-400 font-body mb-2" data-id="element-220">
              Sin tecnicismos. Sin vueltas.
            </p>
            <p className="text-xl sm:text-2xl text-brand-gold font-body font-bold" data-id="element-221">
              👉 Solo lo que funciona.
            </p>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.3} data-id="element-222">
          <div className="text-center" data-id="element-223">
            <CTAButton text="QUIERO LA GUÍA" scrollTo="oferta" size="lg" data-id="element-224" />
          </div>
        </SectionReveal>
      </div>
    </section>;
}